import * as ActionTypes from './EnumTypes/ActionEnumTypes';
import * as AlertActionModel from './Models/AlertActionModel';
import * as AlertModule from 'Modules/AlertModule';
import * as VehiclesModule from 'Modules/VehiclesModule';
import * as FleetModule from 'Modules/FleetModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import { reset } from 'redux-form';
import { history } from 'HelperFunctions/root';

function createAlert(newAlertData: AlertModule.Types.CreateAlertDefinitionRequest) {
    return async dispatch => {
        try {
            dispatch(ViewManagementModule.Actions.showLoader());
            await AlertModule.Connector.createAlert(newAlertData);
            dispatch(createAlertSuccess());
            dispatch(reset('AddAlert'));
            dispatch(ViewManagementModule.Actions.hideLoader());
            history.push('/alerts');
        } catch (err) {
            dispatch(ViewManagementModule.Actions.hideLoader());
        }
    };
}

function getUsersAlerts(params?: URLSearchParams, loaderSm = false) {
    return async dispatch => {
        loaderSm ? dispatch(ViewManagementModule.Actions.showDetailsSidebarLoader()) : dispatch(ViewManagementModule.Actions.showLoader());
        const getUserFleetResponse = await AlertModule.Connector.getUserAlerts(params);
        dispatch(getUsersAlertSuccess(getUserFleetResponse.data));
        loaderSm ? dispatch(ViewManagementModule.Actions.hideDetailsSidebarLoader()) : dispatch(ViewManagementModule.Actions.hideLoader());
    };
}
function getUsersAlertsWithLoaderMain(params?: URLSearchParams) {
    return dispatch => {
        dispatch(getUsersAlerts(params));
    };
}
function getUsersAlertsWithLoaderSmall(params?: URLSearchParams) {
    return dispatch => {
        dispatch(getUsersAlerts(params, true));
    };
}
function updateAlert(alertId: number, updatedAlertData: AlertModule.Types.ModifyAlertDefinitionRequest) {
    return async dispatch => {
        try {
            dispatch(ViewManagementModule.Actions.showLoader());
            await AlertModule.Connector.updateAlert(alertId, updatedAlertData);
            dispatch(updateAlertSuccess());
            history.push('/alerts');
            dispatch(ViewManagementModule.Actions.hideLoader());
        } catch (err) {
            dispatch(ViewManagementModule.Actions.hideLoader());
        }
    };
}
function deleteAlert(alertId: number) {
    return async dispatch => {
        dispatch(ViewManagementModule.Actions.showLoader());
        await AlertModule.Connector.deleteAlert(alertId);
        dispatch(deleteAlertSuccess());
        history.push('/alerts');
        dispatch(setActiveAlert(null));
        await dispatch(getUsersAlerts());
        dispatch(ViewManagementModule.Actions.hideLoader());
    };
}

function enablingAlert(alertId: number, alertEnabled: boolean) {
    return async dispatch => {
        if (alertEnabled) {
            dispatch(disableAlertSuccess(alertId));
            await AlertModule.Connector.disableAlert(alertId);
        } else {
            dispatch(enableAlertSuccess(alertId));
            await AlertModule.Connector.enableAlert(alertId);
        }
    };
}
function enableAlertSuccess(alertId: number): AlertActionModel.EnableAlertSucccess {
    return {
        type: ActionTypes.ALERT.ENABLE_ALERT,
        payload: {
            alertId
        }
    };
}
function disableAlertSuccess(alertId: number): AlertActionModel.DisableAlertSucccess {
    return {
        type: ActionTypes.ALERT.DISABLE_ALERT,
        payload: {
            alertId
        }
    };
}
function getAlertById(alertId: number) {
    return async dispatch => {
        dispatch(ViewManagementModule.Actions.showLoader());
        const response = await AlertModule.Connector.getAlertById(alertId);
        dispatch(setActiveAlert(response.data.alertDefinition));
        dispatch(ViewManagementModule.Actions.hideLoader());
    };
}
function getAlertHistoryLog(params?: URLSearchParams) {
    return async dispatch => {
        try {
            dispatch(ViewManagementModule.Actions.showDetailsSidebarLoader());
            const response = await AlertModule.Connector.getAlertHistoryLog(params);
            await dispatch(getAlertHistoryLogSuccess(response.data.alertHistoryLogPaginatedList));
            dispatch(ViewManagementModule.Actions.hideDetailsSidebarLoader());
        } catch (err) {
            dispatch(ViewManagementModule.Actions.hideDetailsSidebarLoader());
        }
    };
}
function getAlertHistoryLogSuccess(alertHistoryLogPaginatedList: AlertModule.Types.PaginatedListAlertHistoryLogDto): AlertActionModel.GetAlertHistoryLog {
    return {
        type: ActionTypes.ALERT.GET_HISTORY_LOG,
        payload: {
            alertHistoryLogPaginatedList
        }
    };
}
function setActiveAlert(activeAlert: AlertModule.Types.AlertDefinitionDto): AlertActionModel.SetActiveAlert {
    return {
        type: ActionTypes.ALERT.SET_ACTIVE_ALERT,
        payload: {
            activeAlert
        }
    };
}
function setActiveHistoryAlert(activeHistoryAlert: AlertModule.Types.AlertHistoryLogDto): AlertActionModel.SetActiveHistoryAlert {
    return {
        type: ActionTypes.ALERT.SET_ACTIVE_HISTORY_ALERT,
        payload: {
            activeHistoryAlert
        }
    };
}

function deleteAlertSuccess(): AlertActionModel.DeleteAlert {
    return {
        type: ActionTypes.ALERT.DELETE_ALERT
    };
}

function getUsersAlertSuccess(alertResponse: AlertModule.Types.AlertDefinitionsResponse): AlertActionModel.GetUserAlerts {
    return {
        type: ActionTypes.ALERT.GET_USER_ALERTS,
        payload: {
            alertDefinitions: alertResponse.alertDefinitions
        }
    };
}

function updateAlertSuccess(): AlertActionModel.UpdateAlert {
    return {
        type: ActionTypes.ALERT.UPDATE_ALERT
    };
}
function createAlertSuccess(): AlertActionModel.CreateAlert {
    return {
        type: ActionTypes.ALERT.CREATE_ALERT
    };
}
// function enablingAlertSuccess(): AlertActionModel.EnablingAlert {
//     return {
//         type: ActionTypes.ALERT.ENABLING_ALERT
//     };
// }
function manageCars(type: 'ADD' | 'DELETE', car: VehiclesModule.Types.CarDto): AlertActionModel.ManageCars {
    return {
        type: ActionTypes.ALERT.MANAGE_CARS,
        payload: {
            type,
            car
        }
    };
}
function manageFleet(type: 'ADD' | 'DELETE', fleet: FleetModule.Types.CarFleetSimpleDto): AlertActionModel.ManageFleet {
    return {
        type: ActionTypes.ALERT.MANAGE_FLEETS,
        payload: {
            type,
            fleet
        }
    };
}
function manageDomainOfIntrest(type: 'ADD' | 'DELETE', domainOfIntrest: AlertModule.Types.DomainOfInterestDto): AlertActionModel.ManageDomainOfIntrest {
    return {
        type: ActionTypes.ALERT.MANAGE_DOMAIN_OF_INTREST,
        payload: {
            type,
            domainOfIntrest
        }
    };
}
function clearHistoryLog(): AlertActionModel.ClearHistoryLog {
    return {
        type: ActionTypes.ALERT.CLEAR_HISTORY_LOG
    };
}

export {
    createAlert,
    // getUsersAlerts,
    getUsersAlertsWithLoaderMain,
    getUsersAlertsWithLoaderSmall,
    updateAlert,
    deleteAlert,
    getAlertById,
    setActiveAlert,
    setActiveHistoryAlert,
    manageCars,
    manageFleet,
    manageDomainOfIntrest,
    enablingAlert,
    getAlertHistoryLog,
    clearHistoryLog,
    enableAlertSuccess,
    disableAlertSuccess,
    getUsersAlertSuccess
};



// WEBPACK FOOTER //
// ./src/Redux/Actions/AlertActions.ts